import { Link } from 'react-router-dom'
import { BookOpen } from 'lucide-react'

import { rubricSectionHighlight } from '@/components/admin/evaluation-rubrics/rubric-section-ids'
import { EntityManageSection } from '@/components/ui/entity-manage-section'

type SkillDomain = {
  key?: string
  label?: string
  skills?: string[]
}

type RubricSkillDomainsSectionProps = {
  skillDomains: SkillDomain[]
  revisionVersion?: number
  skillsCatalogPath: string
  defaultOpen?: boolean
}

export function RubricSkillDomainsSection({
  skillDomains,
  revisionVersion,
  skillsCatalogPath,
  defaultOpen = true,
}: RubricSkillDomainsSectionProps) {
  return (
    <div id={rubricSectionHighlight('domains')}>
      <EntityManageSection
        title="Skill domains"
        subtitle="Snapshot from the Skill Lexicon at last publish — scoring vocabulary, not live lexicon state. Publishing a revision refreshes it."
        leadingIcon={BookOpen}
        agentHighlight={rubricSectionHighlight('domains')}
        collapsible
        defaultOpen={defaultOpen}
      >
        {skillDomains.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            No skill domains snapshotted yet. Publish to refresh from catalog.
          </p>
        ) : (
          <ul className="divide-y rounded-md border text-sm">
            {skillDomains.map((domain) => (
              <li key={domain.key ?? domain.label} className="px-3 py-3">
                <p className="font-medium">{domain.label ?? domain.key}</p>
                <p className="mt-1 text-muted-foreground">
                  {(domain.skills ?? []).length} skills
                  {(domain.skills ?? []).length > 0
                    ? `: ${(domain.skills ?? []).slice(0, 8).join(', ')}${(domain.skills ?? []).length > 8 ? '…' : ''}`
                    : ''}
                </p>
              </li>
            ))}
          </ul>
        )}
        <p className="mt-3 text-xs text-muted-foreground">
          {revisionVersion ? `Revision v${revisionVersion}` : null}
          {revisionVersion ? ' · ' : null}
          <Link to={skillsCatalogPath} className="underline underline-offset-2">
            Manage catalog →
          </Link>
        </p>
      </EntityManageSection>
    </div>
  )
}
